
import Live3Leap from "../../components/live3/leap/Live3Leap";
import { useSocket } from "../../helpers/socket";


const Live3LeapPage = () => {
    const { socket } = useSocket({});
    return <Live3Leap socket={socket} />
}

export default Live3LeapPage;